import React from 'react';

import { connect } from 'react-redux';

import { Button, ButtonBase, TextField } from '@mui/material';

import TrplSelect from '../../../../../common/TrplControls/TrplSelect';
import PredicateChain from '../../../../../common/PredicateChain';
import ArrowTooltipCss from '../../../../../common/ArrowTooltipCss';

import Node from '../../../../../common/Node';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import ArrowLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowRightIcon from '@mui/icons-material/ChevronRight';

import { trplFormEditColumnWidthes, trplFormEditColumnHeights } from '../../../../../constants';
import { getFormsSelectValues, getLastRstData } from '../../../../../utils';

export default connect((state) => {
  return { jels: state.jels };
})(
  ({
    jels,
    group,
    classes,
    rowIndex,
    setupRbox,
    groupIndex,
    formConcepts,
    deleteGroup,
    groupsLength,
    openFrmEditModal,
    onGroupFrmSelect,
    onGroupFieldChange,
    changeGroupPosition,
    onAccordeonRstChange,
    conceptRestrictionsIds,
    onGroupSizeSelectChange,
    onGroupFrmSelectAccordeonEdit,
  }) => {

    const groupRstId = group.restrictions ? group.restrictions : [];
    const groupConceptKey = group && group.concept_key ? group.concept_key : 'concept';
    const accordeonRstData = groupRstId && groupRstId[0] ? getLastRstData(groupRstId[0], formConcepts[groupConceptKey], setupRbox) : null;
    const conceptId = formConcepts && groupConceptKey && formConcepts[groupConceptKey] ? formConcepts[groupConceptKey] : null;
    const rstOid = accordeonRstData && accordeonRstData.oid ? accordeonRstData.oid : conceptId;

    const isRstInConcept = !groupRstId[0] ||
      (groupRstId && conceptRestrictionsIds && conceptRestrictionsIds[groupConceptKey] && conceptRestrictionsIds[groupConceptKey].has(+groupRstId[0]));

    const frmSelectValues = getFormsSelectValues(jels, rstOid, setupRbox);

    const frmSelectValue = group.frmId && jels.jelData[group.frmId] ? group.frmId : 'none';

    const frmSelectAccordeonEditValue = group.frmEditId && jels.jelData[group.frmEditId] ? group.frmEditId : 'none';

    const frmEditDisabled = frmSelectValue === 'none';
    const frmEditAccDisabled = frmSelectAccordeonEditValue === 'none';

    return (
      <div className={classes.container}>
        <div
          className={classes.column}
          style={{
            marginBottom: '10px',
          }}
        >
          <strong style={{ color: '#c4c4c4' }}>Accordeon</strong>
          <div className={`${classes.alignCenter} ${classes.mb10}`}>
            <TextField
              style={{
                width: 'calc(100% - 220px)',
              }}
              label="Title"
              placeholder="Title"
              value={group.title}
              onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'title', e.target.value)}
            />

            <div style={{ marginBottom: '-15px' }}>
              <Node
                size="sm"
                isLink
                nodeId={rstOid}
                node={setupRbox[rstOid]}
                nodes={setupRbox}
                style={{ margin: '0 10px' }}
              />
            </div>

            <div className={classes.mr10} style={{ width: '100px' }}>
              <TrplSelect
                title="Width"
                margin="none"
                complicatedValues
                values={trplFormEditColumnWidthes}
                value={group.width || 'auto'}
                onChange={(e) => {
                  onGroupSizeSelectChange(rowIndex, groupIndex, 'width', e.target.value);
                }}
              />
            </div>

            <div style={{ width: '100px' }}>
              <TrplSelect
                margin="none"
                title="Height"
                values={trplFormEditColumnHeights}
                complicatedValues
                onChange={(e) => {
                  onGroupSizeSelectChange(rowIndex, groupIndex, 'height', e.target.value);
                }}
                value={group.height || '50vh'}
              />
            </div>
          </div>

          <div className={classes.mb10}>
            <div className={classes.alignEnd}>
              <TrplSelect
                title="Form"
                margin="none"
                complicatedValues
                values={frmSelectValues}
                value={frmSelectValue}
                placeholder='Select form'
                firstChilds={
                  <ButtonBase
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      openFrmEditModal(rowIndex, groupIndex, null, null, 'frmId');
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>
                }
                onChange={(e) => {
                  onGroupFrmSelect(rowIndex, groupIndex, e.target.value);
                }}
              />

              <ButtonBase
                className={classes.ml10}
                style={{
                  opacity: `${frmEditDisabled ? '0.5' : ''}`,
                }}
                disabled={frmEditDisabled}
                onClick={() => openFrmEditModal(rowIndex, groupIndex, true)}
              >
                <EditIcon className={classes.editFrmIcon} />
              </ButtonBase>
            </div>
          </div>

          <div className={classes.mb10}>
            <div className={classes.alignEnd}>
              <TrplSelect
                title="Form on edit"
                margin="none"
                complicatedValues
                values={frmSelectValues}
                value={frmSelectAccordeonEditValue}
                placeholder='Select on edit click form'
                firstChilds={
                  <ButtonBase
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      openFrmEditModal(rowIndex, groupIndex, null, null, 'frmEditId');
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>
                }
                onChange={(e) => {
                  onGroupFrmSelectAccordeonEdit(rowIndex, groupIndex, e.target.value);
                }}
              />

              <ButtonBase
                className={classes.ml10}
                style={{
                  opacity: `${frmEditAccDisabled ? '0.5' : ''}`,
                }}
                disabled={frmEditAccDisabled}
                onClick={() => openFrmEditModal(rowIndex, groupIndex, true, frmSelectAccordeonEditValue)}
              >
                <EditIcon className={classes.editFrmIcon} />
              </ButtonBase>
            </div>
          </div>

          <div className={classes.alignCenter}>
            <div>
              <span style={{ color: '#878787', fontSize: 11 }}>Concept</span>
              <div className={`${classes.alignCenter} ${classes.mr10}`} style={{ marginBottom: '1px' }}>
                {conceptId ?
                  <div className={classes.mr5}>
                    <Node
                      isLink
                      size="xs"
                      nodes={setupRbox}
                      nodeId={conceptId}
                      node={setupRbox[conceptId]}
                    />
                  </div>
                : null}
                <TrplSelect
                  margin="none"
                  values={Object.keys(formConcepts)}
                  value={groupConceptKey}
                  onChange={(e) => {
                    onGroupFieldChange(rowIndex, groupIndex, 'concept_key', e.target.value, () => {
                      onAccordeonRstChange(rowIndex, groupIndex, null);
                    });
                  }}
                />
              </div>
            </div>
            <div className={`${classes.fillAvailable}`}>
              <span style={{ color: '#878787', fontSize: 11 }}>Predicate</span>
              <div className={`${classes.flex}`} style={{ width: '100%' }}>
                <PredicateChain
                  mode="edit"
                  rst={groupRstId}
                  objectTypeOnly={true}
                  maxSelectedRstCount={1}
                  ancestor={formConcepts[groupConceptKey]}
                  addInnerRstCb={({ newSelected }) => {
                    onAccordeonRstChange(rowIndex, groupIndex, newSelected[0]);
                  }}
                  onRemoveRstCb={(props, newSelected) => {
                    onAccordeonRstChange(rowIndex, groupIndex, null);
                  }}
                />
                {isRstInConcept ? null :
                  <div>
                    <ArrowTooltipCss style={{verticalAlign: 'bottom'}} text={'Not valid'}>
                      <ErrorIcon
                        style={{
                          color: '#DD5900',
                          marginLeft: '5px',
                          fontSize: '16px',
                        }}
                      />
                    </ArrowTooltipCss>
                  </div>
                }
              </div>
              
            </div>
          </div>
        </div>

        <div className={classes.justifyEnd}>
          {groupIndex !== 0 ? (
            <ArrowLeftIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex - 1);
              }}
            />
          ) : null}

          {groupIndex !== groupsLength ? (
            <ArrowRightIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex + 1);
              }}
            />
          ) : null}

          <Button size="small" color="secondary" variant="contained" onClick={() => deleteGroup(rowIndex, groupIndex)}>
            Delete group
          </Button>
        </div>
      </div>
    );
  }
);
